import { useRoutes } from 'react-router';
import MainRoute from './interviewee/route';
import NotFoundRoute from './shared/404';

export default function Routes() {
  return useRoutes([MainRoute, NotFoundRoute]);
}
